import React from 'react';
import { Row, Text } from './Common';

const ListEmptyMessage = ({ message }) => (
  <Row justifyContent="center" alignItems="center" style={{ minHeight: 100 }}>
    <Text size={18} style={{ maxWidth: '80%', textAlign: 'center' }}>{message}</Text>
  </Row>
);

ListEmptyMessage.defaultProps = {
  message: 'No data',
};

export default ListEmptyMessage;
